import { useId } from 'react'
import { presets } from './presets'

type UserLevelProps = {
  level: number
  active?: boolean
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
}


export const UserLevel = ({ level, active, disabled, className, style }: UserLevelProps) => {
  const darkGradientId = useId()
  const lightGradientId = useId()
  const filterId = useId()

  const preset = presets[(Math.max(level, 1) - 1) % 10]

  return (
    <svg viewBox="0 0 87 94" fill="none" className={className} style={style}>
      <path d={preset.outerPath} fill={`url(#${darkGradientId})`} stroke="#222222" />
        <g
          opacity={active ? 1 : 0}
          filter={`url(#${filterId})`}
        >
          <path
            d={preset.innerPath}
            fill={`url(#${lightGradientId})`}
          />
        </g>

        <text
          opacity={disabled ? 0.3 : 1}
          fill={active ? 'black' : 'white'}
          xmlSpace="preserve"
          style={{ whiteSpace: 'pre' }}
          fontFamily="Overpass Mono"
          fontSize="18"
          letterSpacing="-0.05em"
        >
          <tspan x={level >= 10 ? '32.36' : '37.45'} y="52.5">
            {level}
          </tspan>
        </text>

      <defs>
        <radialGradient
          id={darkGradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform={preset.outerGradientTransform}
        >
          <stop stopColor="#272727" />
          <stop offset="1" />
        </radialGradient>
        <filter
          id={filterId}
          x="-1"
          y="-7.88586"
          width="89"
          height="109.607"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5671_7712"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5671_7712"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.30017" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_5671_7712"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" dy="-3" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.196761 0 0 0 0 0.159737 0 0 0 0 0.159737 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_5671_7712"
            result="effect3_innerShadow_5671_7712"
          />
        </filter>
        <radialGradient
          id={lightGradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform={preset.innerGradientTransform}
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#4F4F4F" />
        </radialGradient>
      </defs>
    </svg>
  )
}
